import { createSignal } from 'solid-js'

type Props = {
  title: string
  placeholder: string
  type: string
  value: string
}

export default function SettingsInput(props: Props) {
  // toggle dropdown
  const [open, setOpen] = createSignal(false)

  //
  let ref: HTMLDivElement | undefined

  return (
    <div class="settings-input self-star flex min-h-[6rem] min-w-full flex-col justify-center gap-3 rounded-2xl px-4 py-4 exs:px-6 md:max-w-[25rem]">
      <div class="top flex items-center justify-between gap-4">
        <div class="title">{props.title}</div>
        {/* toggle btn */}
        <div class="relative h-[20px] w-[20px] cursor-pointer" onClick={() => setOpen(!open())}>
          <div
            class={`plus absolute left-1/2 top-1/2 h-[1px] w-[20px] -translate-x-1/2 -translate-y-1/2 bg-white transition-all duration-300 ${
              open() ? 'rotate-180 opacity-30' : 'rotate-90 opacity-100'
            }`}
          ></div>
          <div class="minus absolute left-1/2 top-1/2 h-[1px] w-[20px]  -translate-x-1/2 -translate-y-1/2 bg-white"></div>
        </div>
      </div>

      {/* bottom */}
      <div class="bottom">
        <span
          class={`${
            open() ? 'h-0 opacity-0' : 'h-[28px] opacity-100'
          } overflow-hidden transition-all duration-300`}
        >
          {props.value}
        </span>

        <div
          style={{
            'max-height': open() ? `${ref?.getBoundingClientRect().height}px` : '0px',
          }}
          class={`overflow-hidden transition-all duration-300 ${
            open() ? `opacity-100` : 'opacity-0'
          }`}
        >
          {/* input */}
          <div ref={ref} class={`inputs grid items-end gap-4 transition-all duration-300`}>
            <input
              class="w-full rounded-xl border border-transparent bg-white/10 px-4 py-2 outline-none transition-all duration-300 focus:border-cosplay-red"
              type={props.type}
              placeholder={props.placeholder}
            />
            {props.placeholder === 'Password' && (
              <input
                class="w-full rounded-xl border border-transparent bg-white/10 px-4 py-2 outline-none transition-all duration-300 focus:border-cosplay-red"
                type={props.type}
                placeholder="confirm password"
              />
            )}
            <button class="hover:bg-red/10 justify-self-end rounded-xl border border-transparent bg-white/10 px-4 py-2 transition-all duration-300 hover:border-cosplay-red">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
